import React, { useRef, useState } from 'react';
import { Field, reduxForm, formValueSelector, change } from 'redux-form';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip';
import isEmpty from 'lodash/isEmpty';
import {
  DEFAULT_EMAILS_PER_DAY,
  DEFAULT_DELAY_BETWEEN_EMAILS,
} from 'constants/config';
import Button from 'components/buttons/Button';
import RenderFormInput from 'components/forms/RenderFormInput';
import FormSpan from 'components/forms/FormSpan';
import RenderSwitchInput from 'components/forms/RenderSwitchInput';
import Error from 'components/forms/Error';
import WrappedQuill from 'components/Quill';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import { signatureToolbarModules } from 'constants/pitch';
import { requiredValidator, emailValidator, handleBlur } from 'utils/validators';
import { makeStyles } from '@material-ui/styles';

const selector = formValueSelector('EmailImapSmtpConfigForm');


const useStyles = makeStyles(() => ({
  helpIcon: {
    marginLeft: '4px',
    width: '16px',
    height: '16px',
    marginTop: '-3px',
  },
}));

const emailField = (actionType) => {
  let emailFieldReturn;
  if (actionType === 'create') {
    emailFieldReturn = (
      <div className="mb-2">
        { /* eslint-disable-next-line jsx-a11y/label-has-for */ }
        <label htmlFor="email">Sending email address</label>
        <Field
          autocomplete="off"
          lpignore="true"
          maxLength="255"
          id="email"
          name="email"
          component={RenderFormInput}
          type="email"
          onBlur={handleBlur}
          validate={[emailValidator, requiredValidator]}
        />
      </div>
    );
  } else {
    emailFieldReturn = '';
  }
  return emailFieldReturn;
};

const EmailImapSmtpConfigForm = (props) => {
  const [signature, setSignature] = useState(props.initialValues.signature);
  const editor = useRef();
  const classes = useStyles();
  return (
    <form className="instance-form" autoComplete="off" onSubmit={props.handleSubmit}>
      <div className="instance-form__body">
        <Row>
          <div className="ml-auto">
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label className="mt-4">Set as default</label>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="is_primary" className="switch">
              <Field
                autocomplete="off"
                lpignore="true"
                maxLength="255"
                className="primary"
                id="is_primary"
                name="is_primary"
                component={RenderSwitchInput}
                onBlur={handleBlur}
              />
            </label>
          </div>
        </Row>
        <Row>
          <Col sm={12} md={6}>
            <h4>Sending Email</h4>

            {emailField(props.actionType)}

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="sender_name">Sender name</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="sender_name"
              name="sender_name"
              component={RenderFormInput}
              type="text"
              onBlur={handleBlur}
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="smtp_config.username" className="mt-4">SMTP Username</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="smtp_config.username"
              name="smtp_config.username"
              component={RenderFormInput}
              type="text"
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="smtp_config.password" className="mt-4">SMTP password</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="smtp_config.password"
              name="smtp_config.password"
              component={RenderFormInput}
              type="password"
              validate={props.actionType === 'create' ? [requiredValidator] : []}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="smtp_config.host" className="mt-4">SMTP host</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="smtp_config.host"
              name="smtp_config.host"
              component={RenderFormInput}
              type="text"
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="smtp_config.port" className="mt-4">SMTP port</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="smtp_config.port"
              name="smtp_config.port"
              component={RenderFormInput}
              type="number"
              step="1"
              min="0"
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label className="mt-4">SMTP enable SSL</label>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="smtp_config.is_ssl_enabled" className="switch">
              <Field
                autocomplete="off"
                lpignore="true"
                maxLength="255"
                id="smtp_config.is_ssl_enabled"
                className="primary"
                name="smtp_config.is_ssl_enabled"
                component={RenderSwitchInput}
                onBlur={handleBlur}
              />
            </label>
          </Col>
          <Col>
            <h4>Receiving email</h4>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="imap_config.username">IMAP username</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="imap_config.username"
              name="imap_config.username"
              component={RenderFormInput}
              type="text"
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="imap_config.password" className="mt-4">IMAP password</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="imap_config.password"
              name="imap_config.password"
              component={RenderFormInput}
              type="password"
              validate={props.actionType === 'create' ? [requiredValidator] : []}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="imap_config.host" className="mt-4">IMAP host</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="imap_config.host"
              name="imap_config.host"
              component={RenderFormInput}
              type="text"
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="imap_config.port" className="mt-4">IMAP port</label>
            <Field
              autocomplete="off"
              lpignore="true"
              maxLength="255"
              id="imap_config.port"
              name="imap_config.port"
              component={RenderFormInput}
              type="number"
              step="1"
              min="0"
              validate={[requiredValidator]}
            />

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="reply_to_email" className="mt-4">Reply to</label>
            <Field
              maxLength="255"
              name="reply_to_email"
              component={RenderFormInput}
              type="text"
              validate={[emailValidator]}
            />
            <FormSpan color="warning">
            Note: changing the &#8220;Reply to&#8221; to be different than the sending or
            receiving email address will cause analytics to not be captured and
            emails to not appear in your campaign inbox.
            </FormSpan>

            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="imap_config.is_ssl_enabled" className="mt-4">IMAP enable SSL</label>
            {/* eslint-disable-next-line jsx-a11y/label-has-for */}
            <label htmlFor="imapEnableSsl" className="switch">
              <Field
                autocomplete="off"
                lpignore="true"
                maxLength="255"
                id="imap_config.is_ssl_enabled"
                className="primary"
                name="imap_config.is_ssl_enabled"
                component={RenderSwitchInput}
                onBlur={handleBlur}
              />
            </label>
          </Col>
        </Row>
        <div className="mt-4">
          <Row>
            <Col>
              <h4>Deliverability settings</h4>
            </Col>
          </Row>
          <Row>
            <Col sm={12} md={6}>
              {/* eslint-disable-next-line jsx-a11y/label-has-for */}
              <label htmlFor="total_number_of_emails_per_day" className="mt-4">
                Total number of emails per day (rec&apos;d 50; max 1000)
              </label>
              <Field
                autocomplete="off"
                lpignore="true"
                maxLength="255"
                id="total_number_of_emails_per_day"
                name="total_number_of_emails_per_day"
                component={RenderFormInput}
                type="number"
                step="1"
                min="0"
                onBlur={handleBlur}
                validate={[requiredValidator]}
              />
            </Col>
            <Col>
              {/* eslint-disable-next-line jsx-a11y/label-has-for */}
              <label htmlFor="delay_between_each_email_sent" className="mt-4">
                Delay (in seconds) between emails sent (rec&apos;d 300 seconds; min 5 seconds)
              </label>
              <Field
                autocomplete="off"
                lpignore="true"
                maxLength="255"
                id="delay_between_each_email_sent"
                name="delay_between_each_email_sent"
                component={RenderFormInput}
                type="number"
                step="1"
              />

              {/* eslint-disable-next-line jsx-a11y/label-has-for */}
              <label htmlFor="signature" className="mt-4">
              Email Signature
                <Tooltip
                  title="Your signature is added at the end of your email.
                You can include your name, job title, and company name"
                  placement="top"
                >
                  <HelpOutlineOutlinedIcon className={classes.helpIcon} />
                </Tooltip>
              </label>
              <WrappedQuill
                attachRef={(ref) => {
                editor.current = ref;
              }}
                name="signature"
                modules={signatureToolbarModules}
                defaultValue={signature}
                handleOnChange={(value) => {
                setSignature(value);
                props.dispatch(change('EmailOauthConfigForm', 'signature', value));
              }}
                placeholder="Type your signature here"
                isSignatureModal
              />
            </Col>
          </Row>
        </div>

        <Row>
          <Col>
            <Error error={props.error} />
          </Col>
        </Row>
      </div>
      <div className="instance-form__footer mt-4">
        {props.toggleModal && (
        <Button type="button" color="secondary" variant="text" onClick={props.toggleModal}>Cancel</Button>
      )}
        <Button
          color="primary"
          variant="contained"
          className="ml-2"
          disabled={props.pristine || props.submitting}
          type="submit"
        >
        Save
        </Button>
      </div>
    </form>
  );
};

EmailImapSmtpConfigForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  actionType: PropTypes.func.isRequired,
  toggleModal: PropTypes.func,
  submitting: PropTypes.bool,
  pristine: PropTypes.bool,
  error: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  initialValues: PropTypes.shape({
    email: PropTypes.string,
    sender_name: PropTypes.string,
    total_number_of_emails_per_day: PropTypes.number,
    delay_between_each_email_sent: PropTypes.number,
    is_primary: PropTypes.bool,
    signature: PropTypes.string,
    imap_config: PropTypes.shape({
      username: PropTypes.string,
      password: PropTypes.string,
      host: PropTypes.string,
      port: PropTypes.number,
      is_ssl_enabled: PropTypes.bool,
    }),
    smtp_config: PropTypes.shape({
      username: PropTypes.string,
      password: PropTypes.string,
      host: PropTypes.string,
      port: PropTypes.number,
      is_ssl_enabled: PropTypes.bool,
    }),
  }),
};

EmailImapSmtpConfigForm.defaultProps = {
  toggleModal: null,
  submitting: false,
  pristine: true,
  initialValues: {},
  error: null,
};

export default compose(
  connect(
    (state, props) => {
      let initialValues = {
        is_primary: false,
        total_number_of_emails_per_day: DEFAULT_EMAILS_PER_DAY,
        delay_between_each_email_sent: DEFAULT_DELAY_BETWEEN_EMAILS,
        imap_config: { is_ssl_enabled: true },
        smtp_config: { is_ssl_enabled: true },
        signature: '',
      };
      if (!isEmpty(props.initialValues)) {
        initialValues = {
          ...initialValues,
          ...props.initialValues,
          total_number_of_emails_per_day: `${props.initialValues.total_number_of_emails_per_day}`,
          delay_between_each_email_sent: `${props.initialValues.delay_between_each_email_sent}`,
        };
      }
      return {
        initialValues,
        email: selector(state, 'email'),
        sender_name: selector(state, 'sender_name'),
        total_number_of_emails_per_day: selector(state, 'total_number_of_emails_per_day'),
        delay_between_each_email_sent: selector(state, 'delay_between_each_email_sent'),
        is_primary: selector(state, 'is_primary'),
        imap_config: PropTypes.shape({
          username: selector(state, 'username'),
          password: selector(state, 'password'),
          host: selector(state, 'host'),
          port: selector(state, 'port'),
          is_ssl_enabled: selector(state, 'is_ssl_enabled'),
        }),
        smtp_config: PropTypes.shape({
          username: selector(state, 'username'),
          password: selector(state, 'password'),
          host: selector(state, 'host'),
          port: selector(state, 'port'),
          is_ssl_enabled: selector(state, 'is_ssl_enabled'),
        }),
      };
    },
    {},
  ),
  reduxForm({
    form: 'EmailImapSmtpConfigForm',
  }),
)(EmailImapSmtpConfigForm);
